module.exports = __webpack_public_path__ + "static/media/web-site.95171c92.png";